module.exports = __webpack_public_path__ + "static/media/unfav.ba8e28c6.svg";